// src/components/common/chat/ChatDragOverlay.jsx
import React from 'react';
import '../../../../css/common/chat/ChatDragDrop.css';

/**
 * 共通 D&D オーバーレイ（viewport固定）
 * props:
 * - show: boolean
 * - rect: {left, top, width, height}  … position:fixed で張り付け
 * - title, sub, iconClass
 */
export default function ChatDragOverlay({
  show = false,
  rect = null,
  title = 'ここにドロップで送信',
  sub = '画像・PDF・Excel・Word・テキスト（100MBまで）',
  iconClass = 'fa-solid fa-cloud-arrow-up',
}) {
  if (!show || !rect) return null;

  const style = {
    position: 'fixed',
    left: rect.left,
    top: rect.top,
    width: rect.width,
    height: rect.height,
  };

  return (
    <div className="chat-dnd-overlay" style={style} aria-hidden="true">
      <div className="chat-dnd-card" role="presentation">
        <div className="chat-dnd-icon">
          <i className={iconClass} aria-hidden="true" />
        </div>
        <div className="chat-dnd-title">{title}</div>
        <div className="chat-dnd-sub">{sub}</div>
      </div>
    </div>
  );
}
